module.exports = [{
      plugin: require('/var/lib/jenkins/workspace/patient-frontend_master/node_modules/gatsby-plugin-use-query-params/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/var/lib/jenkins/workspace/patient-frontend_master/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
